// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mega-menu[data-v-48c1be0a]{position:absolute;left:-20rem;top:3rem;width:1200px;border-radius:1rem;--tw-bg-opacity:1;background-color:rgb(235 242 254 / var(--tw-bg-opacity));padding:1.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
